<template>
  <BModal
    id="modal-action"
    ref="modal-action"
    centered
    :hide-header="true"
    :hide-footer="true"
    no-close-on-backdrop
    body-class="p-2"
  >
    <div class="flex flex-col justify-center items-center gap-12">
      <img
        :src="image"
        :alt="title"
        width="100"
        height="72"
      >
      <div class="text-black text-center">
        <div class="text-xl font-medium mb-[8px]">
          {{ !retry ? mappingTitle : mappingTitleError }}
        </div>
        <div class="text-base mb-[8px]">
          <span class="font-semibold">{{ !retry ? cardIds.length : failedCard.length }} Kartu</span> {{ !retry ? mappingDesc : mappingError }}
        </div>
        <div
          v-if="!retry"
          class="text-base"
        >
          Mohon verifikasi identitas kamu dengan memasukkan PIN
        </div>
      </div>
      <div
        v-if="!retry"
        class="flex flex-col"
      >
        <PincodeInput
          :key="componentKey"
          v-model="pin"
          :length="6"
          :secure="securePin"
          :disabled="disabledInputOTP"
        />
        <BButton
          type="button"
          variant="flat-primary"
          class="btn-icon"
          @click="toggleVisibilityPin"
        >
          {{ securePin ? 'Tampilkan' : 'Sembunyikan' }}
        </BButton>
      </div>
      <div
        v-else
        class="font-semibold text-[#626262] max-h-[90px] overflow-auto border rounded-lg p-[8px]"
      >
        <div
          v-for="card in failedCard"
          :key="card.id"
          class="flex"
        >
          <div>{{ card.card_name }} - ***{{ card.last_number }}</div>
        </div>
      </div>
    </div>
    <BRow class="flex mt-2">
      <BCol cols="6">
        <BButton
          type="button"
          variant="outline-primary"
          block
          @click="onReset"
        >
          Kembali
        </BButton>
      </BCol>
      <BCol cols="6">
        <BButton
          type="button"
          :variant="pin.length < 6 || loading ? 'secondary' : 'primary'"
          block
          :disabled="pin.length < 6 || loading"
          @click="onSubmit"
        >
          <BSpinner
            v-if="loading"
            small
            variant="light"
          />
          {{ !retry ? 'Konfirmasi' : 'Coba Lagi' }}
        </BButton>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import PincodeInput from 'vue-pincode-input'

export default {
  components: {
    PincodeInput,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    cardIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      pin: '',
      securePin: true,
      disabledInputOTP: false,
      componentKey: 0,
      loading: false,
      retry: false,
      failedCard: [],
    }
  },
  computed: {
    image() {
      const data = {
        'Freeze Kartu': 'https://storage.googleapis.com/komerce/assets/icons/warning.svg',
        'Unfreeze Kartu': 'https://storage.googleapis.com/komerce/assets/icons/success.svg',
        'Cancel Kartu': 'https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg',
      }

      if (this.retry) return 'https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg'
      return data[this.title]
    },
    mappingTitle() {
      const data = {
        'Freeze Kartu': 'Bekukan Kartu (Freeze)',
        'Unfreeze Kartu': ' Aktifkan Kartu (Unfreeze)',
        'Cancel Kartu': 'Cancel Kartu',
      }

      return data[this.title]
    },
    mappingTitleError() {
      const data = {
        'Freeze Kartu': 'Gagal Membekukan Kartu',
        'Unfreeze Kartu': ' Gagal Meng-aktifkan Kartu',
        'Cancel Kartu': 'Gagal Cancel Kartu',
      }

      return data[this.title]
    },
    mappingDesc() {
      const actionMap = {
        'Freeze Kartu': 'dibekukan',
        'Unfreeze Kartu': 'diaktifkan',
        'Cancel Kartu': 'dicancel',
      }

      const action = actionMap[this.title] ?? 'diprocess'
      return `dipilih untuk ${action}`
    },
    mappingError() {
      const data = {
        'Freeze Kartu': 'gagal dibekukan',
        'Unfreeze Kartu': 'gagal diaktifkan',
        'Cancel Kartu': 'gagal dicancel',
      }

      return data[this.title]
    },
  },
  methods: {
    toggleVisibilityPin() {
      this.securePin = !this.securePin
      this.componentKey = Date.now()
    },
    onReset() {
      this.pin = ''
      this.securePin = true
      this.disabledInputOTP = false
      this.retry = false
      this.componentKey = Date.now()
      this.$bvModal.hide('modal-action')
      this.$emit('onChangeSelectAll', false)
      this.$emit('onSelected')
    },
    async onSubmit() {
      this.loading = true
      try {
        const isFreezeOrUnfreeze = ['Freeze Kartu', 'Unfreeze Kartu'].includes(this.title)

        const endpointMap = {
          'Freeze Kartu': '/komcards/api/v1/card/freeze',
          'Unfreeze Kartu': '/komcards/api/v1/card/freeze',
          'Cancel Kartu': '/komcards/api/v1/card/cancel',
        }

        const basePayload = {
          card_ids: this.cardIds,
          pin: this.pin,
        }

        const payload = isFreezeOrUnfreeze
          ? { ...basePayload, is_unfreeze: this.title === 'Unfreeze Kartu' }
          : { ...basePayload }

        const method = this.title === 'Cancel Kartu' ? 'delete' : 'put'
        const url = endpointMap[this.title]

        await newAxiosIns.request({
          url,
          method,
          data: payload,
        })
        this.onReset()
        this.$emit('onRefetch', { data: 25 })
        this.$toast_success({ message: `Berhasil ${this.mappingTitle}` })
        this.loading = false
      } catch (error) {
        const { response: { data: { meta, data } } } = error
        this.loading = false

        this.failedCard = data?.err_cards
        if (meta.message === 'wrong pin numbers') {
          this.$toast_error({ message: 'PIN yang kamu masukan salah!' })
          return
        }
        this.retry = true
      }
    },
  },
}
</script>

<style lang="scss">
[dir] input.vue-pincode-input {
    box-shadow: none!important;
    border-bottom: 2px solid black!important;
    border-radius: 0px!important;
    color: black;
}

[dir] .otp-input {
    width: 40px;
    height: 40px;
    padding: 5px;
    margin: 0 10px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    text-align: center;
  }
  [dir] .otp-input::-webkit-inner-spin-button,
  [dir] .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  [dir] input.vue-pincode-input {
    box-shadow: none!important;
    border-bottom: 2px solid #FF6A3A!important;
    border-radius: 0px!important;
    color: black;
}
  [dir] input.vue-pincode-input:placeholder-shown  {
      box-shadow: none!important;
      border-bottom: 2px solid #828282!important;
      border-radius: 0px!important;
  }
  [dir] input.vue-pincode-input:focus {
    box-shadow: none!important;
    border-bottom: 2px solid #FF6A3A!important;
    border-radius: 0px!important;
}
</style>
